import { render, staticRenderFns } from "./vstdBknDny.vue?vue&type=template&id=0c90b838"
import script from "./vstdBknDny.vue?vue&type=script&lang=js"
export * from "./vstdBknDny.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports